const initialState = {
   studentCertificates: [],
};

export default initialState;
